import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Link from "@material-ui/core/Link";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import { Layout } from "src/layout/Layout";
import * as Dati from "src/Dati";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

interface IGeneratedPolicyLinkProps {
    Id: string;
    Type: string;
}

export const _GeneratedPolicyLink: React.FC<IGeneratedPolicyLinkProps> = ({ Id, Type, ...rest }) => {
    const history = useHistory();
    const { ShowDialog } = useContext(AlertDialogContext);

    const onClickLink = (e: React.SyntheticEvent) => {
        e.preventDefault();
        GetUrl();
    };

    const GetUrl = (): void => {
        const Param: CChiamaWebParametri = {
            URL: `/api/Url/GetURL?template=${Layout.GetTemplateUrl(Type)}&tipo=${Type}&chiave=${Id}`,
            OnRis: OnGetUrl,
            OnErrore: (sender: ChiamaWeb, error: Error) => {
                ShowDialog("ERRORE", error.message, "error");
            }
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnGetUrl = (sender: ChiamaWeb, data: Dati.CRisAPISemplice<string>) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else if (data.Dato) {
            history.push(data.Dato);
        }
    };

    return (
        <Link href="#" onClick={onClickLink}>
            {rest.children}
        </Link>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/GeneratedPolicyLink.tsx